import { render, staticRenderFns } from "./LeftMenu.vue?vue&type=template&id=0524ebff&scoped=true&"
import script from "./LeftMenu.vue?vue&type=script&lang=ts&"
export * from "./LeftMenu.vue?vue&type=script&lang=ts&"
import style0 from "./LeftMenu.vue?vue&type=style&index=0&id=0524ebff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0524ebff",
  null
  
)

export default component.exports